<template>
    <div>
        <div class="a-table--short-no-style">
            <table class="a-table a-table--full-width a-table--hover" cellpadding="0" cellspacing="0">
                <tr>
                    <th width="33%"><h2>Heads of Loss</h2></th>
                    <th width="33%"><h2>Amount</h2></th>
                    <th width="33%"><h2>Interest</h2></th>
                </tr>
                <tr>
                    <td>General Damages (PSLA)</td>
                    <td>{{ currencyFormat(headOfLoss('generalDamages')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('generalDamagesWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Funeral Expenses</td>
                    <td>{{ currencyFormat(headOfLoss('funeralExpenses')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('funeralExpensesWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Loss of Spouse</td>
                    <td>{{ currencyFormat(headOfLoss('lossOfSpouse')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('lossOfSpouseWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Past Cost of Travel</td>
                    <td>{{ currencyFormat(headOfLoss('pastCostOfTravel')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('pastCostOfTravelWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Miscellaneous</td>
                    <td>{{ currencyFormat(headOfLoss('misc')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('miscWithInterest')) }}</td>
                </tr>
                <tr v-if="customHeadsOfLoss.length > 0" v-for="customHead in customHeadsOfLoss">
                    <td>{{ customHead.name }}</td>
                    <td>{{ currencyFormat(customHead.value) }}</td>
                    <td>{{ currencyFormat(customHead.interestAccrued) }}</td>
                </tr>
                <tr>
                    <td>Past Loss of Earnings</td>
                    <td>{{ currencyFormat(headOfLoss('pastLossOfEarnings')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('pastLossOfEarningsWithInterest')) }}</td>
                </tr>
                <tr>
                    <td>Past Cost of Care</td>
                    <td>{{ currencyFormat(headOfLoss('pastCostOfCare')) }}</td>
                    <td>{{ currencyFormat(headOfLoss('pastCostOfCareWithInterest')) }}</td>
                </tr>
                <tr v-if="cruTotalDeductions > 0">
                    <td>CRU Benefit Deductions</td>
                    <td>- {{ currencyFormat(cruTotalDeductions) }}</td>
                    <td></td>
                </tr>
                <tfoot>
                    <tr class="a-table--grey">
                        <td>Subtotal</td>
                        <td>{{ currencyFormat(subTotal) }}</td>
                        <td>{{ currencyFormat(interestTotal) }}</td>
                    </tr>
                    <tr class="a-table--penultimate" v-if="interimPayments.length > 0">
                        <td>Total</td>
                        <td colspan="2">{{ currencyFormat(total) }}</td>
                    </tr>
                    <tr>
                        <td>Total <span v-if="interimPayments.length > 0">less interim payment(s)</span></td>
                        <td colspan="2">{{ currencyFormat(totalLessInterimPayments) }}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
        <div class="step-button flex-state-buttons flex-state-buttons--block a-table--center">
            <div>
                <router-link :to="{ name: 'fatal::estate.step-5' }" class="a-button" tag="button">
                    Back
                </router-link>
                <router-link :to="{ name: 'fatal::estate.documents.list', params : { id: claimId } }" class="a-button" tag="button">
                    View Documents
                </router-link>
            </div>
        </div>
        <reserves-for-claim></reserves-for-claim>

    </div>
</template>

<script>
    import VueHtml5Editor from 'vue-html5-editor';
    const HtmlEditor = new VueHtml5Editor();
    import Control from 'components/form/Control.vue';
    import ControlError from 'components/form/control/Error.vue';
    import {mapGetters, mapActions} from 'vuex';
    import modal from 'components/modal/Modal.vue';
    import currencyFormat from 'mixins/currencyFormat';
    import dateFormat from 'mixins/dateFormat';
    import dropdown from 'components/dropdown/Dropdown.vue';
    import ReservesForClaim from "pages/claims-dashboard/components/ReservesForClaim";

    const numberVal = value => parseFloat(value || 0);

    export default {
        components: {
            ReservesForClaim,
            Control,
            ControlError,
            HtmlEditor,
            dropdown
        },
        mixins: [
            currencyFormat,
            dateFormat,
        ],
        data() {
            return {
                editingContent: null,
                showComparisonSchedule: false,
                theClaim: null,
                loading: false,
                isSaving: false,
            }
        },
        computed: {
            ...mapGetters('fatal/estate/headsOfLoss', {
                headOfLoss: 'value',
                totalInterest: 'totalInterest',
                customHeadsOfLoss: 'headsOfLoss',
                periods: 'periods'
            }),
            ...mapGetters('claim', {
                claimId: 'id'
            }),
            ...mapGetters('fatal/estate/interimPayments', {
                interimPayments: 'interimPayments',
            }),
            ...mapGetters('fatal/estate/cru', [
                'getGeneralDamagesOffset',
                'getPastLossOfEarningsOffset',
                'getPastCostOfCareOffset',
                'getPastCostOfTravelOffset'
            ]),
            ...mapGetters('http', ['apiRouteRequestRunning']),
            subTotal() {
                return numberVal(this.headOfLoss('generalDamages')) +
                    numberVal(this.headOfLoss('funeralExpenses')) +
                    numberVal(this.headOfLoss('lossOfSpouse')) +
                    numberVal(this.headOfLoss('pastLossOfEarnings')) +
                    numberVal(this.headOfLoss('pastCostOfTravel')) +
                    numberVal(this.headOfLoss('pastCostOfCare')) +
                    numberVal(this.headOfLoss('misc')) +
                    numberVal(this.calcCustomHeadsOfLoss) -
                    numberVal(this.cruTotalDeductions);
            },
            interestTotal() {
                return numberVal(this.headOfLoss('generalDamagesWithInterest')) +
                    numberVal(this.headOfLoss('funeralExpensesWithInterest')) +
                    numberVal(this.headOfLoss('lossOfSpouseWithInterest')) +
                    numberVal(this.headOfLoss('pastLossOfEarningsWithInterest')) +
                    numberVal(this.headOfLoss('pastCostOfCareWithInterest')) +
                    numberVal(this.headOfLoss('pastCostOfTravelWithInterest')) +
                    numberVal(this.headOfLoss('miscWithInterest')) +
                    numberVal(this.calcCustomHeadsOfLossInterest);
            },
            total() {
                return this.subTotal + this.interestTotal;
            },
            totalLessInterimPayments() {
                return this.total - numberVal(this.calcInterimPayments);
            },
            downloadUrl() {
                return '/api/v1/download/' + this.claimId;
            },
            calcCustomHeadsOfLoss(){
                let total = 0;
                if (this.customHeadsOfLoss) {
                    this.customHeadsOfLoss.forEach(function (customHead, index) {
                        total = total + numberVal(customHead.value);
                    });
                }
                return total;
            },
            calcCustomHeadsOfLossInterest(){
                let total = 0;
                if (this.customHeadsOfLoss) {
                    this.customHeadsOfLoss.forEach(function (customHead, index) {
                        total = total + numberVal(customHead.interestAccrued);
                    });
                }
                return total;
            },
            calcInterimPayments(){
                return this.interimPayments.reduce((total, interimPayment) => total + numberVal(interimPayment.value), 0);
            },
            cruTotalDeductions() {
                return this.getGeneralDamagesOffset +
                    this.getPastLossOfEarningsOffset +
                    this.getPastCostOfCareOffset +
                    this.getPastCostOfTravelOffset;
            },
            uniqueId() {
                return this._uid;
            }
        },
        methods: {
            ...mapActions('modal', ['toggle']),
            createDocument(type) {
                this.createGeneratedDocument({claimId: this.claimId, type});
            },
            deleteDocument(document) {
                if (this.requesting) {
                    return;
                }
                this.deleteGeneratedDocument(document);
            },
            createComparisonSchedule() {
                this.showComparisonSchedule = true;
            },
            theDocument(index) {
                return this.findDocument(index);
            },
            requestInProgress() {
                return this.apiRouteRequestRunning('/api/v1/generated-documents/load')
            }
        },
    }
</script>


// WEBPACK FOOTER //
// CalculateLossAndGenerateSchedule.vue?6d1cdf8a